import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-form-service',
  templateUrl: './form-service.component.html',
  styleUrls: ['./form-service.component.scss']
})
export class FormServiceComponent implements OnInit {

  @Input('modalForm') modalForm: boolean = false;


  public formService!: FormGroup;
  public services: any [] = [];
  public userSelectedService! : any;
  public userSelectedProfile!: any;
  public hours = ['10:00', '12:00'];
  public amountBookingService: number = 0;


  constructor(
    private formBuilder: FormBuilder,
    ) {}

  ngOnInit(): void {

    this.formService = this.formBuilder.group({
      service: ['', [Validators.required]],
      date: ['', [Validators.required]],
      hour: ['', [Validators.required]],
      units: [0],
      notes: [''],
      unit_price: [''],
    })
  }


  isFormValid(form: FormGroup): boolean {
    return form.valid;
  }

  saveService() {
    if(this.isFormValid(this.formService)) {
      const transformedData = {
          service_profile_id: this.userSelectedProfile.id,
          date: this.formService.value.date,
          hour: this.formService.value.hour,
          units:this.formService.value.units,
      }
      this.services.push(transformedData);
      this.formService.reset();
      this.resetServices;
      this.showForm();
    } else {
      this.markFormAsTouched(this.formService);
    }
  }

  showForm() {
    this.modalForm = !this.modalForm;
  }

  markFormAsTouched(form: FormGroup) {
    Object.values(form.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormAsTouched(control);
      }
    });
  }

  onChange(value: any) {
    this.userSelectedService = this.services[value.target.value];
  }

  onChangeProfile(value:any) {
    this.userSelectedProfile = this.userSelectedService.profiles[value.target.value];
  }

  resetServices(){
    this.userSelectedProfile = undefined;
    this.userSelectedService = undefined
  }

  calculateAmountService(){
    const units = this.formService.value.units || 0;
    const unitPrice = this.userSelectedProfile?.price || 0;
    this.amountBookingService = ( units * unitPrice);
  }
}
